//import('./pb23-selectors.css');
import { getParameterByName } from "@api/utils_2020";

const pb23Selectors = {
	service: null,
	type: null,
	format: null,
	finish: null,
    init: function () {

		pb23Selectors.service = Util.service("WSPortobelloSite", true, {
            exceptionHandler: alertInterface.showError,
            reflectSuccess: function (service) {
                pb23Selectors.service = service;
            },
            reflectError: function () {
                alert("Erro de conexão, verifique sua conexão com a internet.");
                window.reload();
            },
        });
		/*
		$('body').off('click','.pb23-selectors .selectors-group.color ul li a:not(.disabled)').on('click','.pb23-selectors .selectors-group.color ul li a:not(.disabled)', function(e)
		{
			e.preventDefault();
			var idGroupColor = $(this).data('id');
			$('.pb23-selectors .selectors-group.color ul li a').removeClass('selected');
			$(this).addClass('selected');
			$('.pb23-selectors .selectors-group.type ul li a').removeClass('selected');
			$('.pb23-selectors .selectors-group.size ul li a').removeClass('selected');
			$('.pb23-selectors .selectors-group.finish ul li a').removeClass('selected');

			$('.pb23-selectors .selectors-group.type ul li a').addClass('blocked');
			$('.pb23-selectors .selectors-group.size ul li a').addClass('blocked');
			$('.pb23-selectors .selectors-group.finish ul li a').addClass('blocked');

			pb23Selectors.format = null;
			pb23Selectors.type = null;
			pb23Selectors.finish = null;
				
			pb23Selectors.service.getProductGroupColorNavArray(idGroupColor, channel, { success: function(data)
				{
					console.log(data);
					productsJson = data.products;

					UtilUi.loadTemplate("assets/components-new/pb23-selectors/pb23-selectors--options.tpl", function (dataOn, tpl) {
						const htmlContent = tpl.fetch({
							salesChannel: channel,
//							selectedType: selectedType,
//							type: type,
//							subType: subType,
//							class3: class3,
//							class4: class4,
							formats: data.formats,
							types: data.types,
							finishings: data.finishings,
							product: (typeof product != 'undefined')?product:null,
							noSel: true
						});
						$(".pb23-selectors .selectors-group.type").remove();
						$(".pb23-selectors .selectors-group.size").remove();
						$(".pb23-selectors .selectors-group.finish").remove();
						$(".pb23-selectors .selectors-group.color").after(htmlContent);
						$(".pb23-selectors .selectors-group.type ul li a.selected").trigger('click');


						if (Object.keys(data.formats).length == 1 && Object.keys(data.finishings).length == 1 && Object.keys(data.types).length == 1)
							{
								const type = Object.keys(data.types)[0];
								const format = Object.keys(data.formats)[0];
								const finishing = Object.keys(data.finishings)[0];
				
								var toLink = productsJson[type][format][finishing]['link'];
								window.location.href = toLink;
							}
					});
					
				}
			 });
			e.stopPropagation();
			return false;
		});
		*/

		$('body').off('click','.pb23-selectors .selectors-group ul li a.disabled').on('click','.pb23-selectors .selectors-group ul li a.disabled', function(e)
		{
			e.preventDefault();
			e.stopPropagation();
			return false;
		});
		$('body').off('click','.pb23-selectors .selectors-group:not(.color) ul li a:not(.disabled,.blocked)').on('click','.pb23-selectors .selectors-group:not(.color) ul li a:not(.disabled,.blocked)', function(e)
		{
			e.preventDefault();
			var selectorType = $(this).data('selector');
			switch (selectorType)
			{
				case 'type':
					pb23Selectors.type = $(this).data('type');
					$('.pb23-selectors .selectors-group.type ul li a').removeClass('selected');
					$('.pb23-selectors .selectors-group.size ul li a').removeClass('selected');
					$('.pb23-selectors .selectors-group.finish ul li a').removeClass('selected');
					pb23Selectors.format = null;
					pb23Selectors.finish = null;
					//$('.selectors-group.size ul li a').removeClass('selected');
					//$('.selectors-group.finish ul li a').removeClass('selected');
					break;
				case 'format':
					pb23Selectors.format = $(this).data('format');
					$('.pb23-selectors .selectors-group.size ul li a').removeClass('selected');
					$('.pb23-selectors .selectors-group.finish ul li a').removeClass('selected');
					pb23Selectors.finish = null;
					//$('.selectors-group.finish ul li a').removeClass('selected');
					break;
				case 'finish':
					pb23Selectors.finish = $(this).data('finish');
					$('.pb23-selectors .selectors-group.finish ul li a').removeClass('selected');
					break;
			}
			$(this).addClass('selected');
			pb23Selectors.updateSelectors();
			return false;
		});
		if ($('.pb23-selectors .selectors-group.type ul li a.selected').length > 0)
		{
			pb23Selectors.type = $('.pb23-selectors .selectors-group.type ul li a.selected').data('type');
			pb23Selectors.updateSelectors(true);
		}
		if ($('.pb23-selectors .selectors-group.size ul li a.selected').length > 0)
		{
			pb23Selectors.format = $('.pb23-selectors .selectors-group.size ul li a.selected').data('format');
			pb23Selectors.updateSelectors(true);
		}
		if ($('.pb23-selectors .selectors-group.finish ul li a.selected').length > 0)
		{
			pb23Selectors.finish = $('.pb23-selectors .selectors-group.finish ul li a.selected').data('finish');
			pb23Selectors.updateSelectors(true);
		}

		$("body").on("click", ".pb23-selectors .jsChannelSelect", function(evt) {
            evt.preventDefault();
            var url = window.location.href;
			url = url.split('?')[0];
            var channel = $(this).data("channel");
			if(channel) {
				window.location.href = url + '?selChannel=' + channel + '#selector';
			} else {
				window.location.href = url + '#selector';
			}
			//window.location.reload(true);
            return false;
        });

		if ($('.selectors-group.color ul li').length == 0)
		{
			$('.selectors-group.color').hide();
			$('.pb23-selectors--mobile input[name="color"]').parent().hide();
		}
    },
	updateSelectors: function(noGo)
	{
		if (pb23Selectors.type)
		{
			$('.pb23-selectors .selectors-group.size ul li a').each(function(index, elem)
			{
				var format = $(elem).data('format');
				if (typeof productsJson[pb23Selectors.type][format] == 'undefined')
				{
					$(elem).addClass('disabled');
					$(elem).parent().addClass('disabled');
					$(elem).removeClass('selected');
				}
				else
				{
					$(elem).removeClass('disabled');
					$(elem).parent().removeClass('disabled');
				}
			}
			);

			if (pb23Selectors.format)
			{
				$('.pb23-selectors .selectors-group.finish ul li a').each(function(index, elem)
				{
					var finish = $(elem).data('finish');
					if (typeof productsJson[pb23Selectors.type][pb23Selectors.format][finish] == 'undefined')
					{
						$(elem).addClass('disabled');
						$(elem).parent().addClass('disabled');
						$(elem).removeClass('selected');
					}
					else
					{
						$(elem).removeClass('disabled');
						$(elem).parent().removeClass('disabled');
					}
				}
				);
			}
			else if (!noGo)
			{
				$('.pb23-selectors .selectors-group.size ul li:not(.disabled)').first().find('a').trigger('click');
				return;
			}


			if (pb23Selectors.format && pb23Selectors.finish && !noGo)
			{
				//var code = productsJson[pb23Selectors.type][pb23Selectors.format][pb23Selectors.finish]['code'];
				var link = productsJson[pb23Selectors.type][pb23Selectors.format][pb23Selectors.finish]['link'];
				//alert(code);
				//alert(link);
				var idDiscount = getParameterByName('discount');

				if (idDiscount)
				{
					link += '?discount='+idDiscount;
				}
				window.location.href=link;
			} else if ( pb23Selectors.format && !pb23Selectors.finish && !noGo)
			{
				$('.pb23-selectors .selectors-group.finish ul li:not(.disabled)').first().find('a').trigger('click');
				return;
			}
		}
	}
}

// initialize component
window.loadedComponents.push({ component: 'pb23-search-card--product', init: pb23Selectors.init });

export default () => {
    pb23Selectors.init();
}